import { render, staticRenderFns } from "./DetailPhotos.vue?vue&type=template&id=11ec9eb8&"
import script from "./DetailPhotos.vue?vue&type=script&lang=js&"
export * from "./DetailPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports